/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * @minItems 2
 * @maxItems 2
 */
export type MoveResult = [string[], string[]];
